import React, { createContext, useState, useContext } from 'react';
import { useSnackbar } from 'notistack';

// Création du contexte de notification
const NotificationContext = createContext();

// Hook personnalisé pour utiliser le contexte de notification
export const useNotification = () => {
  return useContext(NotificationContext);
};

// Fournisseur du contexte de notification
export const NotificationProvider = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();

  // Fonction pour afficher une notification de succès
  const showSuccess = (message) => {
    enqueueSnackbar(message, { variant: 'success' });
  };

  // Fonction pour afficher une notification d'erreur
  const showError = (message) => {
    enqueueSnackbar(message, { variant: 'error' });
  };

  // Fonction pour afficher une notification d'information
  const showInfo = (message) => {
    enqueueSnackbar(message, { variant: 'info' });
  };

  // Fonction pour afficher une notification d'avertissement
  const showWarning = (message) => {
    enqueueSnackbar(message, { variant: 'warning' });
  };

  // Fonction générique pour afficher une notification
  const showNotification = (message, type = 'info') => {
    enqueueSnackbar(message, { variant: type });
  };

  // Valeur du contexte
  const value = {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    showNotification
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export { NotificationContext };
